import {
    Component,
    Input,
    TemplateRef,
    SimpleChanges,
    OnInit,
    OnDestroy,
    Output,
    EventEmitter,
} from '@angular/core';
import { CommonModule } from '@angular/common';
import { Subscription } from 'rxjs';
import { TabNavigationService } from '../../services/tab-navigation.service';

export interface TabOption {
    label: string;
    value: string;
    template: TemplateRef<any>;
    data?: string;
}
@Component({
    selector: 'app-sub-tabs',
    standalone: true,
    imports: [CommonModule],
    templateUrl: './sub-tabs.component.html',
    styleUrl: './sub-tabs.component.scss',
})
export class SubTabsComponent implements OnInit, OnDestroy {
    private subscription = new Subscription();
    @Input() tabs: TabOption[] = [];
    @Input() mainTabSlug!: string;
    @Input() selectedTab: string | null = null;
    @Output() togTab: EventEmitter<any> = new EventEmitter();
    activeTab: string | null = null;

    constructor(private tabNavigationService: TabNavigationService) {}

    ngOnInit() {
        this.subscription.add(
            this.tabNavigationService.subTab$.subscribe((subTabData) => {
                if (subTabData && subTabData.mainTab === this.mainTabSlug) {
                    this.activeTab = subTabData.subTab;
                } else if (!subTabData && this.tabs.length > 0) {
                    // Reset to first tab when sub-tab state is cleared
                    this.activeTab = this.tabs[0].value;
                }
            })
        );
    }

    ngOnChanges(changes: SimpleChanges) {
        if (changes['tabs'] && this.tabs.length > 0 && !this.activeTab) {
            this.activeTab = this.tabs[0].value;
        }

        // Handle selectedTab changes from parent
        if (changes['selectedTab'] && this.selectedTab) {
            this.activeTab = this.selectedTab;
        }
    }

    toggleTab(value: string) {
        this.activeTab = value;
        this.togTab.emit(value);
    }

    ngOnDestroy() {
        this.subscription.unsubscribe();
    }

    makeSlug(str: string) {
        if (!str) return;
        const lwr = str.toLocaleLowerCase();
        return str
            ?.toLowerCase()
            ?.replaceAll(' ', '_')
            ?.replaceAll('_-_', '_')
            ?.replaceAll(',_', '_')
            ?.replaceAll(')_', '_')
            ?.replaceAll('(', '');
    }
}
